/* eslint-disable */
// FirebaseAuthContext.tsx
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import * as Sentry from '@sentry/react';
import * as React from 'react';
import toast from 'react-hot-toast';

import { auth, firestore } from '../services/Firebase';
import { strings } from '../strings';

type User = undefined;
type ContextState = { user: User };

const FirebaseAuthContext = React.createContext<ContextState | undefined>(undefined);

const FirebaseAuthProvider: React.FC = ({ children }) => {
  const [user, setUser] = React.useState<any>(undefined);
  const value = { user };

  React.useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (userAuth) => {
      const allowedRoles = ['user', 'admin'];

      if (!userAuth) {
        setUser(null);
        Sentry.setUser(null);
        return;
      }

      const userRef = doc(firestore, 'usersWeb', userAuth.uid);
      getDoc(userRef).then((user) => {
        const userData = user.data();

        if (!userData || !allowedRoles.includes(userData.Role)) {
          setUser(null);
          Sentry.setUser(null);
          signOut(auth);
          toast.error(strings.noPermissions);
          return;
        }

        Sentry.setUser({ id: userAuth?.uid });
        setUser(user);
        return;
      });
    });

    return unsubscribe;
  }, []);

  return <FirebaseAuthContext.Provider value={value}>{children}</FirebaseAuthContext.Provider>;
};

function useFirebaseAuth() {
  const context = React.useContext(FirebaseAuthContext);
  if (context === undefined) {
    throw new Error('useFirebaseAuth must be used within a FirebaseAuthProvider');
  }
  return context.user;
}

export { FirebaseAuthProvider, useFirebaseAuth };
